import { ArrowRightAlt, ArrowRightOutlined, AutoFixHighOutlined, CheckBoxOutlined, CloseOutlined, DescriptionOutlined, DoneAllOutlined, DoneOutline, PersonOutline } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import AndroidIcon from 'icons/Technologies/Android.icon';
import { useCandidateStore } from 'store/candidateStore';

export const Route = createFileRoute('/(partner)/_partner/interview-overview')({
  component: RouteComponent,
})

function RouteComponent() {

    const navigate = useNavigate();
    
    const { selectedCandidate } = useCandidateStore();

    const getStatusText = (status?: number) => {
        switch (status) {
            case 0: return 'Not Run';
            case 1: return 'In Progress';
            case 2: return 'Completed';
            case 3: return 'Passed';
            case 4: return 'Failed';
            default: return '-';
        }
    }

    const formatTime = (seconds?: number) => {
        if (!seconds) return '-';
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
    }

    const formatDate = (iso?: string) => {
        if (!iso) return '-';
        const d = new Date(iso);
        if (isNaN(d.getTime()) || d.getFullYear() === 1) return '-';
        return d.toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });
    }
    return (

        <Box sx={{
            paddingX: '125px',
            paddingTop: '32px'
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: {xs: 'column', md: 'row'},
                alignItems: {xs: 'start', md: 'center'},
                justifyContent: 'space-between',
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: '32px',
                gap: {xs: '20px', md: '0px'}
            }}>
                <Box sx={{display: 'flex', gap: '24px', alignItems: 'center'}}>
                    <Box sx={{padding: '8px', border: '1px solid var(--Light-Gray)', width: 'fit-content', height: 'fit-content', borderRadius: '100%'}}>
                        <PersonOutline />
                    </Box>
                    <Box>
                        <Typography variant='h1'>{selectedCandidate?.candidateName ?? '-'}</Typography>
                        <Typography>Finished on {formatDate(selectedCandidate?.completedOnUtc)}</Typography>
                    </Box>
                </Box>
                <Box>
                    <Typography sx={{ color: 'var(--Interviewer-Lightest-Black)', fontWeight: 600, fontSize:'14px'}}>Interview</Typography>
                    <Typography sx={{ color: 'var(--Interviewer-Black)', fontWeight: 600, fontSize:'16px'}}>Junior Developer?</Typography>
                </Box>
                <Box sx={{display: 'flex', gap: '12px'}}>
                    <AndroidIcon/>
                    <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                        <Typography sx={{ color: 'var(--Interviewer-Lightest-Black)', fontWeight: 600, fontSize:'14px'}}>Technology</Typography>
                        <Typography sx={{ color: 'var(--Interviewer-Black)', fontWeight: 600, fontSize:'16px'}}>Android?</Typography>
                    </Box>
                </Box>
            </Box>


            {/* Statistics summary section */}
            <Box sx={{
                display: 'flex',
                flexDirection: {xs: 'column', md: 'row'},
                gap: '20px',
                pt: '20px',
                pb: '64px'
            }}>
                {/* Interview Time Card */}
                <Box sx={{
                    flex: 1,
                    background: '#fff',
                    borderRadius: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    padding: '24px',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '28px'}}>
                        <Typography sx={{ fontWeight: 600, color: 'var(--Interviewer-Black)', width: '100%', fontSize: '16px' }}>Total Interview Time</Typography>
                        <Box sx={{background: 'linear-gradient(308.71deg, #31C07D 0.09%, #47C5FB 100%)', borderRadius: '8px', px: '20px', py: '13px', width: '100%' }}>
                            <Typography sx={{ color: '#fff', fontWeight: 500, fontSize: '32px', textAlign: 'center' }}>
                              {selectedCandidate?.totalTime}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '28px' }}>
                        <Typography sx={{ fontWeight: 600, color: 'var(--Interviewer-Black)', width: '100%', fontSize: '16px' }}>Average Answer Time</Typography>
                        <Box sx={{background: '#47C5FB1A', borderRadius: '12px', px: '20px', py: '13px', width: '100%' }}>
                            <Typography sx={{ color: 'var(--Interviewer-Black)', fontWeight: 500, fontSize: '32px', textAlign: 'center' }}>
                                ?
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {/* Pick/Choose Card */}
                <Box sx={{
                    flex: 1,
                    background: '#fff',
                    borderRadius: '16px',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <CheckBoxOutlined />
                        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: 'var(--Interviewer-Black)' }}>Pick/Choose</Typography>
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#E0F6EC', borderRadius: '8px', padding: '12px' }}>
                        <Typography sx={{ color: 'var(--Interviewer-Green)', fontWeight: 700, fontSize: '16px' }}>
                          Correct ?
                        </Typography>
                        <DoneAllOutlined sx={{ color: 'var(--Interviewer-Green)' }}/>
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#FDEAEA', borderRadius: '8px', padding: '12px' }}>
                        <Typography sx={{ color: 'var(--Red-Error-Color)', fontWeight: 700, fontSize: '16px' }}>
                          Wrong ?
                        </Typography>
                        <CloseOutlined sx={{ color: 'var(--Red-Error-Color)' }}/>
                    </Box>
                </Box>
                {/* Textual Card */}
                <Box sx={{
                    flex: 1,
                    background: '#fff',
                    borderRadius: '16px',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <DescriptionOutlined />
                        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: 'var(--Interviewer-Black)' }}>Textual</Typography>
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#E0F6EC', borderRadius: '8px', padding: '12px' }}>
                        <Typography sx={{ color: 'var(--Interviewer-Green)', fontWeight: 700, fontSize: '16px' }}>- ?</Typography>
                        <DoneAllOutlined sx={{ color: 'var(--Interviewer-Green)' }} />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#FDEAEA', borderRadius: '8px', padding: '12px' }}>
                        <Typography sx={{ color: 'var(--Red-Error-Color)', fontWeight: 700, fontSize: '16px' }}>- ?</Typography>
                        <CloseOutlined sx={{ color: 'var(--Red-Error-Color)' }}/>
                    </Box>
                </Box>
            </Box>

            {/* Action Buttons */}
            <Box sx={{display: 'flex', gap: '20px', flexDirection: {xs: 'column', md: 'row'}, maxWidth: '100%'}}>
                <Button 
                    variant='contained' 
                    sx={{width: '100%', py: {xs: '12px', md: '24px'}}} 
                    onClick={() => navigate({
                        to: '/review-mode',
                    })}>
                    <Typography variant='h2' sx={{color: '#fff'}}>Begin review</Typography>
                    <ArrowRightAlt />
                </Button>
                <Button variant='text' sx={{
                    backgroundColor: 'var(--Light-Gray)',
                    width: '100%',
                    py: {xs: '12px', md: '24px'}
                }}>
                    <Box sx={{backgroundColor: 'var(--Interviewer-Green)', borderRadius: '100%', p: '3px', width: '24px', height: '24px'}}>
                        <AutoFixHighOutlined sx={{color: '#fff', width: '100%', height: '100%'}} />
                    </Box>
                    <Typography variant='h2' sx={{color: 'var(--Interviewer-Black)', pl: '10px'}}>Interviewer AI assistance</Typography>
                </Button>
            </Box>
        </Box>


    )
}
